const {
    VITE_ALGOLIA_INDEX_NAME,
} = import.meta.env;

const hitsCssRoot = "ais-Hits-list";
const hitsCssClasses = ["grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6"];
const sortFiltersAlphabetical = {
    container: "sort-by-container",
    items: [
        { value: `${VITE_ALGOLIA_INDEX_NAME}`, label: 'Nieuwste eerst' },
        { value: `${VITE_ALGOLIA_INDEX_NAME}_title_asc`, label: 'Alfabetisch (A-Z)' },
        { value: `${VITE_ALGOLIA_INDEX_NAME}_title_desc`, label: 'Alfabetisch (Z-A)' },
    ]
};
const sortFiltersNews = {
    container: "sort-by-container",
    items: [
        { value: `${VITE_ALGOLIA_INDEX_NAME}`, label: 'Nieuwste eerst' },
        { value: `${VITE_ALGOLIA_INDEX_NAME}_posted_at_timestamp_asc`, label: 'Oudste eerst' }
    ]
}

const agendaSearch = () => {
    const selectedTemplate = "agenda";
    const hitsPerPage = 12;
    const searchPlaceholder = "Zoek een event...";
    const hasSearch = true;
    const staticFilterString = `section.handle:"agendaPages"`;
    const filters = [
        { 
            label: "Onderwerp",
            container: "tags", 
            attribute: "tags.title",
            type: "dropdown"
        },
    ];
    const sortFilters = [];
    const overrideIndex = `${VITE_ALGOLIA_INDEX_NAME}_start_date_timestamp_asc`;
    const hitsCssClasses = ["grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6"];
    
    return { 
        selectedTemplate, 
        hitsPerPage,
        searchPlaceholder,
        hasSearch,
        staticFilterString, 
        filters,
        sortFilters, 
        hitsCssRoot,
        hitsCssClasses,
        overrideIndex,
    };
}

const experienceSearch = () => {
    const selectedTemplate = "card";
    const hitsPerPage = 12;
    const searchPlaceholder = "Zoek een ervaring...";
    const hasSearch = true;
    const staticFilterString = `section.handle:"experiences"`;
    const filters = [
        { 
            label: "Onderwerp",
            container: "tags", 
            attribute: "tags.title",
            type: "dropdown"
        },
    ];

    const sortFilters = [];
    
    return { 
        selectedTemplate, 
        hitsPerPage,
        searchPlaceholder,
        hasSearch,
        staticFilterString, 
        filters,
        sortFilters, 
        hitsCssRoot,
        hitsCssClasses 
    };
}

const globalSearch = () => {
    const selectedTemplate = "basic";
    const hitsPerPage = 10;
    const searchPlaceholder = "Zoeken...";
    const hasSearch = true;
    const staticFilterString = "";
    const filters = [
        { 
            label: "Type",
            container: "entry", 
            attribute: "entry_type.type",
            type: "dropdown"
        },
        { 
            label: "Onderwerp",
            container: "tags", 
            attribute: "tags.title",
            type: "dropdown"
        },
    ];
    const sortFilters = [
        sortFiltersAlphabetical, 
        { ...sortFiltersAlphabetical, container: "sort-by-container--desktop",}
    ];
    const hitsCssClasses = ["flex flex-col gap-6"];

    return { 
        selectedTemplate, 
        hitsPerPage,
        searchPlaceholder,
        hasSearch,
        staticFilterString, 
        filters,
        sortFilters, 
        hitsCssRoot,
        hitsCssClasses,
    };
}

const newsSearch = () => {
    const selectedTemplate = "card";
    const hitsPerPage = 12;
    const searchPlaceholder = "Zoek een artikel...";
    const staticFilterString = `section.handle:"news"`;
    const hasSearch = true;
    const filters = [
        { 
            label: "Onderwerp",
            container: "tags", 
            attribute: "tags.title",
            type: "dropdown"
        },
    ];

    const sortFilters = [
        sortFiltersNews, 
        { ...sortFiltersNews, container: "sort-by-container--desktop",}
    ];

    return { 
        selectedTemplate, 
        hitsPerPage,
        searchPlaceholder,
        hasSearch,
        staticFilterString, 
        filters,
        sortFilters, 
        hitsCssRoot,
        hitsCssClasses 
    };
}

const pgoSearch = () => {
    const selectedTemplate = "pgo";
    const hitsPerPage = 1000;
    const searchPlaceholder = "Zoeken...";
    const hasSearch = false;
    const staticFilterString = `entry_type.handle:"pgoDetail"`
    const filters = [
        {
            container: "pgo_data_sources_selection",
            attribute: "pgo_data_sources_selection.title",
            label: "Zorgverlener",
            type: "dropdown__static",
            description: "Tip: je kunt meerdere hokjes aanvinken. En je hoeft niet bij alle vragen iets aan te vinken."
        },
        {
            container: "pgo_personal_data_selection",
            attribute: "pgo_personal_data_selection.title",
            label: "Eigen Gegevens",
            type: "dropdown__static",
            description: "Let op: dit zijn gegevens die je helemaal zelf invoert in je PGO. Deze gegevens komen dus NIET uit jouw medisch dossier en kunnen ook (nog) niet gedeeld worden met je zorgverlener(s) via MedMij."
        },
        {
            container: "pgo_personal_measurements_selection",
            attribute: "pgo_personal_measurements_selection.title",
            label: "Eigen metingen",
            type: "dropdown__static",
        },
        {
            container: "pgo_extra_options_selection",
            attribute: "pgo_extra_options_selection.title",
            label: "Extra mogelijkheden",
            type: "dropdown__static",
        },
        {
            container: "pgo_type_of_apps_selection",
            attribute: "pgo_type_of_apps_selection.title",
            label: "Platform",
            type: "dropdown__static"
        },
        {
            container: "pgo_app_connections_selection",
            attribute: "pgo_app_connections_selection.title",
            label: "App Koppelingen",
            type: "dropdown__static"
        },
        {
            container: "pgo_helpdesk_channels_selection",
            attribute: "pgo_helpdesk_channels_selection.title",
            label: "Helpdesk Kanalen",
            type: "dropdown__static"
        },        
        {
            container: "pgo_languages_selection",
            attribute: "pgo_languages_selection.title",
            label: "Taal",
            type: "dropdown__static",
            description: "Let op: de taal geldt dan alleen voor de PGO zelf, niet voor bijvoorbeeld de medische gegevens die je via MedMij in je PGO zet."
        },
        {
            container: "pgo_security_selection",
            attribute: "pgo_security_selection.title",
            label: "Beveiliging",
            type: "dropdown__static"
        },
        {
            container: "pgo_accessibility_selection",
            attribute: "pgo_accessibility_selection.title",
            label: "Toegankelijkheid",
            type: "dropdown__static"
        },
        {
            container: "pgo_medmij_compatible",
            attribute: "pgo_medmij_compatible",
            label: "Werkt met link of QR-code zorgverlener",
            type: "toggleRefinement"
        },
    ];

    const pgoSortFilters = {
        container: "sort-by-container",
        items: [
            { value: `${VITE_ALGOLIA_INDEX_NAME}_pog_desc`, label: 'Hoogste cijfer eerst' },
            { value: `${VITE_ALGOLIA_INDEX_NAME}_title_asc`, label: 'Alfabetisch (A-Z)' },
            { value: `${VITE_ALGOLIA_INDEX_NAME}_title_desc`, label: 'Alfabetisch (Z-A)' },
        ]
    }
    const sortFilters = [
        pgoSortFilters, 
        { ...pgoSortFilters, container: "sort-by-container--desktop",}
    ];
    const hitsCssClasses = ["flex flex-col gap-6"];

    const overrideIndex = `${VITE_ALGOLIA_INDEX_NAME}_pog_desc`;

    return { 
        selectedTemplate, 
        hitsPerPage,
        searchPlaceholder,
        hasSearch,
        staticFilterString, 
        filters,
        sortFilters, 
        hitsCssRoot,
        hitsCssClasses, 
        overrideIndex
    };
}


const researchSearch = () => {
    const selectedTemplate = "research";
    const hitsPerPage = 12;
    const searchPlaceholder = "Zoek een onderzoek...";
    const staticFilterString = `section.handle:"research"`;
    const hasSearch = true;
    const filters = [
        { 
            label: "Onderwerp",
            container: "tags", 
            attribute: "tags.title",
            type: "dropdown"
        },
        { 
            label: "Status",
            container: "research_status", 
            attribute: "research_status.label",
            type: "dropdown"
        },
    ];

    const sortFilters = [];
    
    return { 
        selectedTemplate, 
        hitsPerPage,
        searchPlaceholder,
        hasSearch,
        staticFilterString, 
        filters,
        sortFilters, 
        hitsCssRoot,
        hitsCssClasses 
    };
}

const kidzSearch = () => {
    const selectedTemplate = "kidz";
    const hitsPerPage = 12;
    const searchPlaceholder = "Zoek, bijvoorbeeld op naam of trefwoord";
    const staticFilterString = `section.handle:"kidzPage"`;
    const hasSearch = true;
    const filters = [
        { 
            label: "Thema",
            container: "tags", 
            attribute: "tags.title",
            type: "dropdown"
        },
      { 
            label: "Status",
            container: "kidz_status", 
            attribute: "kidz_status.label",
            type: "dropdown"
        },
    ];

    const sortFilters = [];
    
    return { 
        selectedTemplate, 
        hitsPerPage,
        searchPlaceholder,
        hasSearch,
        staticFilterString, 
        filters,
        sortFilters, 
        hitsCssRoot,
        hitsCssClasses 
    };
}

export const settings = {
    agendaSearch,
    experienceSearch,
    globalSearch,
    newsSearch,
    pgoSearch,
    researchSearch,
    kidzSearch,
}

